
  async function loadToonLibrary() {
    const cdnUrls = [
      'https://esm.sh/@toon-format/toon',
      'https://unpkg.com/@toon-format/toon/dist/index.mjs',
      'https://cdn.skypack.dev/@toon-format/toon'
    ];
    
    for (const url of cdnUrls) {
      try {
        console.log(`Trying to load TOON from: ${url}`);
        const module = await import(url);
        if (module.encode) {
          window.ToonEncoder = { encode: module.encode };
          console.log(`TOON encoder loaded successfully from: ${url}`);
          return true;
        }
      } catch (error) {
        console.warn(`Failed to load from ${url}:`, error);
      }
    }
    
    // If all CDNs fail, provide a simple fallback implementation
    console.warn('All TOON CDNs failed, using fallback implementation');
    window.ToonEncoder = {
      encode: (data) => {
        // Simple fallback that creates a TOON-like format
        if (Array.isArray(data)) {
          data = { data: data };
        }
        
        function toToon(obj, depth = 0) {
          const indent = '  '.repeat(depth);
          let result = '';
          
          for (const [key, value] of Object.entries(obj)) {
            if (Array.isArray(value) && value.length > 0) {
              const firstItem = value[0];
              if (typeof firstItem === 'object' && firstItem !== null) {
                const keys = Object.keys(firstItem);
                result += `${indent}${key}[${value.length}]{${keys.join(',')}}:\\n`;
                for (const item of value) {
                  const values = keys.map(k => item[k] || '').join(',');
                  result += `${indent}  ${values}\\n`;
                }
              } else {
                result += `${indent}${key}[${value.length}]: ${value.join(',')}\\n`;
              }
            } else if (typeof value === 'object' && value !== null) {
              result += `${indent}${key}:\\n`;
              result += toToon(value, depth + 1);
            } else {
              result += `${indent}${key}: ${value}\\n`;
            }
          }
          return result;
        }
        
        return toToon(data).trim();
      }
    };
    return false;
  }
  
  try {
    await loadToonLibrary();
    // Import and initialize our main application
    await import('./src/main.ts');
  } catch (error) {
    console.error('Failed to initialize application:', error);
    document.body.innerHTML = '<div style="padding: 20px; text-align: center; color: red;">Failed to initialize application. Please refresh the page.</div>';
  }
